type Props = {
	letters: string
	background?: string
	borderWidth: number
	square: boolean
}

// Amount to offset text vertically to get centered text. If this proves to be
// variable, this should be controllable from each widgetapp instead. We'll just
// have to live with this as a hard configuration, since there appears to be no
// way to effectively center capital letters exactly.
const baselineOffset = 0.05

export const SvgLogo = ({ letters, background = 'none', borderWidth, square }: Props) => (
	<svg viewBox='0 0 1 1' aria-hidden>
		{square ? (
			<rect
				x={borderWidth / 2}
				y={borderWidth / 2}
				width={1 - borderWidth}
				height={1 - borderWidth}
				fill={background}
				strokeWidth={borderWidth}
				stroke='currentcolor'
			/>
		) : (
			<circle
				cx={0.5}
				cy={0.5}
				r={0.5 - borderWidth}
				fill={background}
				strokeWidth={borderWidth}
				stroke='currentcolor'
			/>
		)}
		<text
			fontSize={0.5}
			x={0.5}
			y={0.5 + baselineOffset}
			textAnchor='middle'
			dominantBaseline='middle'
			fill='currentcolor'
		>
			{letters}
		</text>
	</svg>
)
